import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgExpand = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M18.34 9.61004C18.21 9.61004 18.08 9.56004 17.99 9.46004L11.99 3.46004L6.01002 9.44004C5.81002 9.64004 5.50002 9.64004 5.30002 9.44004C5.10002 9.24004 5.10002 8.93004 5.30002 8.73004L11.99 2.04004L18.69 8.74004C18.89 8.94004 18.89 9.25004 18.69 9.45004C18.59 9.55004 18.46 9.60004 18.34 9.60004V9.61004Z' />
    <path d='M12.01 21.95L5.31002 15.25C5.11002 15.05 5.11002 14.74 5.31002 14.54C5.51002 14.34 5.82002 14.34 6.02002 14.54L12.01 20.54L17.99 14.56C18.19 14.36 18.5 14.36 18.7 14.56C18.9 14.76 18.9 15.07 18.7 15.27L12.01 21.96V21.95Z' />
  </svg>
);
export default SvgExpand;
